<template>
    <div>
        <div class="l-element">
            <heading-form-label text="メールアドレス" :label="label" />
            <form-input-text
                class="is-mgb4"
                type="text"
                id="input-mail-address"
                name="mail-address"
                :value="inputMailAddress"
                v-model="inputMailAddress"
                placeholder="例）pictlink@example.com"
                length="50"
                @blur="blurFunc"
                @input="emit(isValidMailAddress, inputMailAddress)"
                data-jest="input-mail-address"
            />
            <p
                v-if="!isValidMailAddress && inputMailAddress"
                class="m-text-comments is-caution"
                data-jest="error-format"
            >
                有効なメールアドレス形式ではありません
            </p>
            <p
                v-if="isEmpty"
                class="m-text-comments is-caution"
                data-jest="error-empty"
            >
                メールアドレスを入力してください
            </p>
        </div>
        <div
            class="l-element is-mgb8"
            v-if="inputMailAddress && isValidMailAddress"
            data-jest="confirm-area"
        >
            <heading-form-label text="確認用" />
            <p class="c-text-mail" data-jest="confirm-text">
                {{ inputMailAddress }}
            </p>

            <p class="m-text-comments is-caution is-mgb0">
                入力ミスが多くなっております。一度ご確認ください
            </p>
        </div>
    </div>
</template>

<script>
import HeadingFormLabel from "../atoms/HeadingFormLabel.vue";
import FormInputText from "../atoms/FormInputText.vue";
import * as formValidateUtil from "../../util/FormValidateUtil";
export default {
    name: "FormInputMailAddress",
    components: { HeadingFormLabel, FormInputText },
    props: {
        /**
         * メールアドレスの初期値
         */
        initialMailAddress: {
            type: String,
            default: "",
            required: false
        },
        /**
         * 「必須(required)」か「任意(any)」を選択
         */
        label: {
            type: String,
            required: false,
            default: ""
        }
    },
    emits: ['input'],
    data() {
        return {
            isEmpty: false,
            inputMailAddress: ""
        };
    },
    computed: {
        isValidMailAddress() {
            if (this.inputMailAddress.length !== 0) {
                this.isEmpty = false;
            }
            return formValidateUtil.isValidMailAddress(this.inputMailAddress);
        }
    },
    methods: {
        emit(isValidMailAddress, inputMailAddress) {
            if(isValidMailAddress){
                this.$emit("input", inputMailAddress);
            } else {
                this.$emit("input", null);
            }
        },
        blurFunc() {
            this.isEmpty = this.inputMailAddress.length === 0;
        }
    },
    created() {
        this.inputMailAddress = this.initialMailAddress;
    }
};
</script>

<style scoped lang="scss">
@use "../../../scss/v2/base/variables";
.c-text-mail {
    padding: 9px 0 13px 0;
    font-size: 1.6rem;
    font-weight: bold;
    color: variables.$color-pictlink-black-50;
}
</style>
